import { Link } from "react-router-dom";
import { Images, FileImage, Sparkles, Calculator, BookOpen, HelpCircle, ChevronRight } from "lucide-react";

const TILES = [
  { to: "/sc/marketing/creatives", Icon: Images, title: "Creatives", desc: "Ready-made WhatsApp posts with your QR baked in", testid: "creatives" },
  { to: "/sc/marketing/flyer", Icon: FileImage, title: "My Flyer", desc: "Personalised campaign flyer to share", testid: "flyer" },
  { to: "/sc/marketing/calculator", Icon: Calculator, title: "Savings Calculator", desc: "Live ROI estimate for your customer", testid: "calculator" },
  { to: "/sc/marketing/schemes", Icon: Sparkles, title: "Incentive Schemes", desc: "How your commission is calculated", testid: "schemes" },
  { to: "/sc/marketing/explainers", Icon: BookOpen, title: "Subsidy Explainers", desc: "Talking points on govt. subsidy & benefits", testid: "explainers" },
  { to: "/sc/marketing/faq", Icon: HelpCircle, title: "FAQ", desc: "Answers to common customer questions", testid: "faq" },
];

export default function ScMarketing() {
  return (
    <div data-testid="sc-marketing">
      <div className="font-mono text-[9px] uppercase tracking-[0.3em] text-[#1B5E20]">Grow your referrals</div>
      <h1 className="text-2xl font-bold mt-1 text-slate-900">Toolkit.</h1>
      <p className="text-sm text-slate-500 mt-1.5">Everything you need to pitch, calculate and close a solar sale.</p>

      <div className="mt-5 space-y-2.5" data-testid="sc-toolkit-tiles">
        {TILES.map((t) => (
          <Link
            key={t.to}
            to={t.to}
            data-testid={`sc-toolkit-tile-${t.testid}`}
            className="flex items-center gap-3 bg-white border border-slate-200 rounded-2xl p-4 shadow-[0_2px_8px_rgba(15,23,42,0.04)] hover:shadow-[0_4px_12px_rgba(15,23,42,0.08)] hover:border-emerald-300 active:scale-[0.99] transition-all"
          >
            <div className="w-10 h-10 rounded-xl bg-emerald-50 border border-emerald-200 flex items-center justify-center flex-shrink-0">
              <t.Icon className="w-5 h-5 text-[#1B5E20]" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-bold text-slate-900">{t.title}</div>
              <div className="text-[11px] text-slate-500 mt-0.5">{t.desc}</div>
            </div>
            <ChevronRight className="w-4 h-4 text-slate-400 flex-shrink-0" />
          </Link>
        ))}
      </div>
    </div>
  );
}
